// extracted by mini-css-extract-plugin
export default {"fields":"styles_fields__ZrxY7","field":"styles_field__MscEN","label":"styles_label__HChOq","footer":"styles_footer__JfzD9"};